export const appConfig = {
  companyName: 'EnzRossi Connect',
  websiteUrl: 'https://enzrossi.com',
  privacyPolicyUrl: 'https://connect.enzrossi.com/privacy',
  termOfUseUrl: 'https://connect.enzrossi.com/terms',
  contactEmail: 'support@enzrossi.com',
  sentryDsn: '',
};
